<template><article><h1>Using slots</h1>
<div class="tip custom-block"><p class="custom-block-title">TIP</p>
<p>The <code v-pre>v-slot:</code>(symbol <code v-pre>#</code>) used in the example is based on vue version 2.6.0 or higher, and the lower version can be replaced with <code v-pre>slot</code> and <code v-pre>slot-scoped</code>. See the official documentation for details.</p>
</div>
<h3 id="slider-slot"><a class="header-anchor" href="#slider-slot" aria-hidden="true">#</a> Slider slot</h3>
<p><example :value="example1"></example></p>
<h3 id="tooltip-slot"><a class="header-anchor" href="#tooltip-slot" aria-hidden="true">#</a> Tooltip slot</h3>
<p><example :value="example2"></example></p>
<h3 id="label-slot"><a class="header-anchor" href="#label-slot" aria-hidden="true">#</a> Label slot</h3>
<p><example :value="example3"></example></p>
<h3 id="step-slot"><a class="header-anchor" href="#step-slot" aria-hidden="true">#</a> Step slot</h3>
<p><example :value="example4"></example></p>
<h3 id="process-slot"><a class="header-anchor" href="#process-slot" aria-hidden="true">#</a> Process slot</h3>
<p><example :value="example5"></example></p>
</article></template>

<script>
  import examples from '@/examples/components-slots.ts'
  export default {
    data () {
      return {
        ...examples
      }
    }
  }
</script>